import { call, put, takeLatest } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    fetchReport,
    reportFetched,
    reportFetchFailed,
} from '../contractorWithdrawalsReport';

function* fetchReportEffect({ payload }) {
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.contractorWithdrawalsReport,
            method: 'GET',
            queryParams: payload || {},
        });
        yield put(reportFetched(response));
    } catch (e) {
        yield put(reportFetchFailed(e.message));
    }
}

export const contractorWithdrawalsReportSagas = [
    takeLatest(fetchReport.type, fetchReportEffect),
];
